export const CardNetworks = {
    VISA: ['visa'],
    MASTERCARD: ['mastercard'],
    // MAESTRO: ['maestro'], // TODO: took out temporarily as it is not supported in the UK according to Google
    AMEX: ['american-express', 'amex', 'american express'],
    DISCOVER: ['discover'],
    INTERAC: ['interac'],
    JCB: ['jcb', 'japan credit bureau']
}